import React, { useState } from 'react';
import { Calculator, Download, FileText, X } from 'lucide-react';
const MOCK_PAYROLL = [{
  id: '1',
  empId: 'EMP001',
  name: 'John Doe',
  present: 22,
  half: 0,
  absent: 0,
  gross: 50000,
  deductions: 0,
  net: 50000
}, {
  id: '2',
  empId: 'EMP002',
  name: 'Sarah Smith',
  present: 20,
  half: 1,
  absent: 1,
  gross: 45000,
  deductions: 2000,
  net: 43000
}, {
  id: '3',
  empId: 'EMP003',
  name: 'Mike Johnson',
  present: 18,
  half: 0,
  absent: 4,
  gross: 40000,
  deductions: 7200,
  net: 32800
}, {
  id: '4',
  empId: 'EMP004',
  name: 'Emily Davis',
  present: 21,
  half: 2,
  absent: 0,
  gross: 48000,
  deductions: 1500,
  net: 46500
}, {
  id: '5',
  empId: 'EMP005',
  name: 'Robert Wilson',
  present: 22,
  half: 0,
  absent: 0,
  gross: 55000,
  deductions: 0,
  net: 55000
}];
export function Payroll() {
  const [selectedPayslip, setSelectedPayslip] = useState<any>(null);
  return <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-1405">
      {/* Controls */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex flex-wrap items-center justify-between gap-4" data-id="element-1406">
        <div className="flex items-center gap-4" data-id="element-1407">
          <div data-id="element-1408">
            <label className="block text-xs font-semibold text-gray-500 uppercase mb-1" data-id="element-1409">
              Select Month
            </label>
            <select className="border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white min-w-[200px]" data-id="element-1410">
              <option data-id="element-1411">October 2023</option>
              <option data-id="element-1412">September 2023</option>
              <option data-id="element-1413">August 2023</option>
            </select>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-1414">
          <button className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 rounded-lg flex items-center gap-2 transition-colors" data-id="element-1415">
            <Download size={16} data-id="element-1416" />
            Export CSV
          </button>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 transition-colors shadow-sm" data-id="element-1417">
            <Calculator size={16} data-id="element-1418" />
            Generate Payroll
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1419">
        <div className="overflow-x-auto" data-id="element-1420">
          <table className="w-full text-sm text-left" data-id="element-1421">
            <thead className="bg-gray-50 text-xs font-semibold text-gray-600 uppercase border-b border-gray-200" data-id="element-1422">
              <tr data-id="element-1423">
                <th className="px-6 py-4" data-id="element-1424">Employee</th>
                <th className="px-6 py-4 text-center" data-id="element-1425">Present</th>
                <th className="px-6 py-4 text-center" data-id="element-1426">Half Days</th>
                <th className="px-6 py-4 text-center" data-id="element-1427">Absent</th>
                <th className="px-6 py-4 text-right" data-id="element-1428">Gross Salary</th>
                <th className="px-6 py-4 text-right" data-id="element-1429">Deductions</th>
                <th className="px-6 py-4 text-right" data-id="element-1430">Net Salary</th>
                <th className="px-6 py-4 text-center" data-id="element-1431">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1432">
              {MOCK_PAYROLL.map(row => <tr key={row.id} className="hover:bg-gray-50 transition-colors" data-id="element-1433">
                  <td className="px-6 py-4" data-id="element-1434">
                    <div className="font-medium text-gray-900" data-id="element-1435">{row.name}</div>
                    <div className="text-xs text-gray-500" data-id="element-1436">{row.empId}</div>
                  </td>
                  <td className="px-6 py-4 text-center font-medium text-green-600" data-id="element-1437">
                    {row.present}
                  </td>
                  <td className="px-6 py-4 text-center font-medium text-blue-600" data-id="element-1438">
                    {row.half}
                  </td>
                  <td className="px-6 py-4 text-center font-medium text-red-600" data-id="element-1439">
                    {row.absent}
                  </td>
                  <td className="px-6 py-4 text-right font-mono text-gray-600" data-id="element-1440">
                    ${row.gross.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right font-mono text-red-500" data-id="element-1441">
                    -${row.deductions.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right font-mono font-bold text-gray-900" data-id="element-1442">
                    ${row.net.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-1443">
                    <button onClick={() => setSelectedPayslip(row)} className="text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 px-3 py-1.5 rounded-md text-xs font-bold transition-colors flex items-center gap-1 mx-auto" data-id="element-1444">
                      <FileText size={14} data-id="element-1445" />
                      Payslip
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Payslip Modal */}
      {selectedPayslip && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-in fade-in duration-200" data-id="element-1446">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-1447">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-1448">
              <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2" data-id="element-1449">
                <FileText size={20} className="text-indigo-600" data-id="element-1450" />
                Salary Slip
              </h3>
              <button onClick={() => setSelectedPayslip(null)} className="text-gray-400 hover:text-gray-600 p-1" data-id="element-1451">
                <X size={20} data-id="element-1452" />
              </button>
            </div>

            <div className="p-6 space-y-6" data-id="element-1453">
              <div className="flex justify-between items-start" data-id="element-1454">
                <div data-id="element-1455">
                  <h4 className="font-bold text-xl text-gray-900" data-id="element-1456">
                    {selectedPayslip.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-1457">
                    ID: {selectedPayslip.empId}
                  </p>
                </div>
                <div className="text-right" data-id="element-1458">
                  <p className="text-sm font-bold text-gray-800" data-id="element-1459">
                    October 2023
                  </p>
                  <span className="inline-block mt-1 px-2 py-0.5 bg-green-100 text-green-700 text-xs font-bold rounded" data-id="element-1460">
                    Paid
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 py-4 border-y border-gray-100" data-id="element-1461">
                <div className="text-center" data-id="element-1462">
                  <p className="text-xs text-gray-500 uppercase" data-id="element-1463">Present</p>
                  <p className="font-bold text-gray-900" data-id="element-1464">
                    {selectedPayslip.present}
                  </p>
                </div>
                <div className="text-center border-x border-gray-100" data-id="element-1465">
                  <p className="text-xs text-gray-500 uppercase" data-id="element-1466">Half Day</p>
                  <p className="font-bold text-gray-900" data-id="element-1467">
                    {selectedPayslip.half}
                  </p>
                </div>
                <div className="text-center" data-id="element-1468">
                  <p className="text-xs text-gray-500 uppercase" data-id="element-1469">Absent</p>
                  <p className="font-bold text-red-600" data-id="element-1470">
                    {selectedPayslip.absent}
                  </p>
                </div>
              </div>

              <div className="space-y-3" data-id="element-1471">
                <div className="flex justify-between text-sm" data-id="element-1472">
                  <span className="text-gray-600" data-id="element-1473">Basic Salary</span>
                  <span className="font-mono font-medium text-gray-900" data-id="element-1474">
                    ${selectedPayslip.gross.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-1475">
                  <span className="text-gray-600" data-id="element-1476">Allowances</span>
                  <span className="font-mono font-medium text-gray-900" data-id="element-1477">
                    $0
                  </span>
                </div>
                <div className="flex justify-between text-sm text-red-600" data-id="element-1478">
                  <span data-id="element-1479">Deductions (Absent/Late)</span>
                  <span className="font-mono font-medium" data-id="element-1480">
                    -${selectedPayslip.deductions.toLocaleString()}
                  </span>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-200 flex justify-between items-center" data-id="element-1481">
                <span className="font-bold text-gray-900" data-id="element-1482">Net Salary</span>
                <span className="text-2xl font-bold text-indigo-600 font-mono" data-id="element-1483">
                  ${selectedPayslip.net.toLocaleString()}
                </span>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50" data-id="element-1484">
              <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 rounded-lg flex items-center justify-center gap-2 transition-colors shadow-sm" data-id="element-1485">
                <Download size={18} data-id="element-1486" />
                Download PDF
              </button>
            </div>
          </div>
        </div>}
    </div>;
}